import { IInterest } from "api/types";
import { useAppState } from "AppState";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import WizardButtonGroup from "components/common/WizardButtonGroup/WizardButtonGroup";
import { ButtonGroup } from "components/common/WizardButtonGroup/WizardButtonGroup.style";

import InterestSelector from "components/ElementSelector/ElementSelector";
import Interests from "components/ElementSelector/Interests/Interests";
import { TabletDataContext } from "components/Gates/TabletDataGate";
import { shouldHideUsageType } from "components/UsageTypeSelector/utils";
import React, { useContext } from "react";
import { Routes } from "router";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import styled from "styled-components";
import useReactRouter from "use-react-router";

export default function InterestSelection(): JSX.Element {
  const {
    locationName,
    availableInterests,
    selectedInterestIds,
    setSelectedInterestIds
  } = useAppState();
  const {
    setInterests: setInterestsInOnboarding
  } = OnboardingContainer.useContainer();
  const { history } = useReactRouter();
  const tabletData = useContext(TabletDataContext);

  const setSelectedInterests = (changedInterests: IInterest[]) => {
    setSelectedInterestIds(
      changedInterests.filter(x => x.checked).map(x => x.id)
    );
    setInterestsInOnboarding(changedInterests);
  };
  const goToSignUpCustomerPersonalInfo = () =>
    history.push(Routes.SignUpCustomerPersonalInfo);

  const goToSignUpUsageTypeSelection = () =>
    history.push(Routes.SignUpUsageTypeSelection);

  const goToSignUpTcpa = () => history.push(Routes.SignUpTcpa);

  return (
    <PanelLayout
      title={locationName}
      titleSecondary="What are your interests?"
      centerContent
    >
      <>
        <InterestSelector
          title="Choose your interests"
          allElements={availableInterests}
          initialSelectedIds={selectedInterestIds}
          onChange={setSelectedInterests}
          component={<Interests />}
        />
        <ButtonGroup>
          <WizardButtonGroup
            leftCaption="previous"
            rightCaption="next"
            leftClick={
              shouldHideUsageType(tabletData)
                ? goToSignUpTcpa
                : goToSignUpUsageTypeSelection
            }
            rightClick={goToSignUpCustomerPersonalInfo}
          />
        </ButtonGroup>
      </>
    </PanelLayout>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Onboarding/SignUp/InterestSelection/InterestSelection.tsx